/* eslint-disable react/jsx-key */

/** @jsx jsx **/
import { PageProps, graphql, useStaticQuery } from 'gatsby'
import ReactMarkdown from 'react-markdown'
import { Box, Container, Grid, Heading, Text, jsx } from 'theme-ui'
import { FluidImageObjectType } from '~/@types/models'
import { hubspotFormIds } from '~/common/hubspot'
import Layout from '~/components/layout'
import HeadingV2 from '~/componentsV2/heading'
import { HubspotForm } from '~/utils/hubspotForm'
import { trackCompleteRegistration } from '~/utils/marketing/track'

type QueryResult = {
  pageData: {
    frontmatter: {
      headerVariant: string
      title: string
      description: string
      sections: Array<{
        image: FluidImageObjectType
        imageMobile: FluidImageObjectType
        title: string
        description: string
        template: number | string
      }>
    }
    html: string
  }
}
const BespokeServicesPage = (props: PageProps) => {
  const query = useStaticQuery<QueryResult>(graphql`
    query {
      pageData: markdownRemark(frontmatter: { templateKey: { eq: "bespokeServices" } }) {
        frontmatter {
          headerVariant
          title
          description
          sections {
            title
            description
            template
            image {
              ...heroImage
            }
            imageMobile {
              ...heroImage
            }
          }
        }
        html
      }
    }
  `)

  const {
    frontmatter: { sections, title, description },
  } = query.pageData
  const {
    location: { pathname },
  } = props
  return (
    <Layout headerVariant="default" title={title} description={description}>
      <Container
        as="section"
        sx={{
          my: [50, null, 75],
        }}
      >
        <Grid gap={[70, null, null, 120]}>
          <Box
            sx={{
              paddingX: [0, '100px', '150px'],
            }}
          >
            <HeadingV2
              level="1"
              sx={{
                mb: [26, null, 42],
                textAlign: ['center', 'start'],
              }}
            >
              <ReactMarkdown
                source={title}
                disallowedTypes={['paragraph', 'image', 'link', 'strong', 'emphasis']}
                unwrapDisallowed
              />
            </HeadingV2>
            <HubspotForm
              formId={hubspotFormIds.bespokeServices as string}
              onSubmit={() => {
                trackCompleteRegistration({
                  pageName: pathname,
                })
              }}
            />
          </Box>
          {sections.map(section => {
            // const templateNumber = Number(section.template)
            // const template2 = templateNumber === 2
            // const imageSource = mapImageSources({
            //   images: {
            //     default: section.image,
            //     mobile: section.imageMobile,
            //   },
            // })
            return (
              <Box as="section">
                <Grid
                  // gap={[40, null, null, 60]}
                  columns={['1fr', null, null, null, '1fr']}
                  sx={{
                    alignItems: 'start',
                  }}
                >
                  <Box
                    sx={{
                      gridRowStart: [1, null, 3, null, 3],
                      gridColumn: ['1 / span 1', null, ' 1 / span 2', null, '1 / span 2'],
                    }}
                  >
                    <Box
                      sx={{
                        mt: [50],
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <Heading
                        as="h2"
                        sx={{
                          px: 6,
                          fontSize: [28, 48],
                          fontWeight: 400,
                          textAlign: ['center', 'start'],
                        }}
                      >
                        <ReactMarkdown
                          source={section.title}
                          disallowedTypes={['paragraph', 'image', 'link', 'strong', 'emphasis']}
                          unwrapDisallowed
                        />
                      </Heading>
                    </Box>
                    <Box sx={{ fontSize: '16px', lineHeight: '34px' }}>
                      <Text sx={{ textAlign: 'center', letterSpacing: 'normal' }}>
                        <ReactMarkdown
                          source={section.description}
                          disallowedTypes={['paragraph', 'image', 'link', 'strong', 'emphasis']}
                          unwrapDisallowed
                        />
                      </Text>
                    </Box>
                  </Box>
                </Grid>
              </Box>
            )
          })}
        </Grid>
      </Container>
    </Layout>
  ) as JSX.Element
}

export default BespokeServicesPage
